import { BrandProvider } from '../themes';
import {
    Filter,
    FilterProvider,
    JobListProvider,
    JobStoryProvider,
    MapProvider,
    WidgetErrorFallback,
} from 'rwl-ui';
import {
    GlobalProvider,
    WhenGlobalReady,
    GlobalConfig,
} from '../hooks/useGlobal';
import { Layout } from '../Layout';
import { ConfigFetcher } from '../fetchers/ConfigFetcher';
import { JobFetcher } from '../fetchers/JobFetcher';
import { URLUpdater } from '../components/URLUpdater/URLUpdater';
import { SalesToolMap } from '../components/SalesToolMap';
import { MediaModalContainer } from '../components/MediaModalContainer';
import 'react-image-gallery/styles/css/image-gallery.css';
import { ModalStackProvider } from '../hooks/useModalStack';
import { JobListContainer } from '../components/JobListContainer';
import { SessionTracker } from '../fetchers/SessionTracker';
import { PendoInit } from '../fetchers/Pendo/PendoInit';
import { TechnicianProvider } from '../hooks/useTechnician';
import { EngagementMonitor } from '../components/EngagementMonitor';
import { GeolocationProvider } from '../hooks/useGeolocation';
import { PlacesAutocompleteProvider } from '../hooks/usePlacesAutocomplete';
import { JobStoryModal } from '../components/JobStoryModal';
import { GlobalLoader } from '../Layout/Loader';
import { FilterFetcher } from '../fetchers/ConfigFetcher/FilterFetcher';
import { MountedQueryClientProvider } from 'rwl-shared/dist/hooks';
import * as Sentry from '@sentry/react';

export const Widget = (props: GlobalConfig): JSX.Element => {
    return (
        <Sentry.ErrorBoundary fallback={<WidgetErrorFallback />}>
            <GlobalProvider {...props}>
                <MountedQueryClientProvider>
                    <ConfigFetcher />
                    <BrandProvider>
                        <WhenGlobalReady>
                            <ModalStackProvider>
                                <TechnicianProvider>
                                    <MapProvider>
                                        <PlacesAutocompleteProvider>
                                            <GeolocationProvider>
                                                <FilterProvider>
                                                    <FilterFetcher />
                                                    <JobListProvider>
                                                        <JobStoryProvider>
                                                            <EngagementMonitor />
                                                            <SessionTracker />
                                                            <JobFetcher />
                                                            <URLUpdater />
                                                            <PendoInit />
                                                            <Layout
                                                                Sidebar={
                                                                    <Filter />
                                                                }
                                                                JobListContent={
                                                                    <JobListContainer />
                                                                }
                                                                MapContent={
                                                                    <SalesToolMap />
                                                                }
                                                            />
                                                            <JobStoryModal />
                                                            <MediaModalContainer />
                                                        </JobStoryProvider>
                                                    </JobListProvider>
                                                </FilterProvider>
                                            </GeolocationProvider>
                                        </PlacesAutocompleteProvider>
                                    </MapProvider>
                                </TechnicianProvider>
                            </ModalStackProvider>
                        </WhenGlobalReady>
                        <GlobalLoader />
                    </BrandProvider>
                </MountedQueryClientProvider>
            </GlobalProvider>
        </Sentry.ErrorBoundary>
    );
};
